import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';
import { SALON } from '../data/content';

const Footer = () => {
  return (
    <footer className="bg-neutral-950 text-neutral-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2 lg:col-span-1">
            <h3 className="font-serif text-3xl font-bold text-white mb-4">
              {SALON.name}
            </h3>
            <p className="text-sm text-neutral-400 leading-relaxed max-w-xs">
              Your trusted family salon in {SALON.city}. Premium hair, skin & nail services
              for men & women in a relaxing environment.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg text-gold mb-4">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="hover:text-gold btn-transition">Home</Link></li>
              <li><Link to="/about" className="hover:text-gold btn-transition">About</Link></li>
              <li><Link to="/services" className="hover:text-gold btn-transition">Services</Link></li>
              <li><Link to="/nail-studio" className="hover:text-gold btn-transition">Nail Studio</Link></li>
              <li><Link to="/gallery" className="hover:text-gold btn-transition">Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-gold btn-transition">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h4 className="font-serif text-lg text-gold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-gold flex-shrink-0" />
                <a href={`tel:${SALON.phoneRaw}`} className="hover:text-gold btn-transition">
                  {SALON.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-gold flex-shrink-0" />
                <span>{SALON.addressLine1}, {SALON.addressLine2}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-gold flex-shrink-0" />
                <span>{SALON.timing}</span>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="font-serif text-lg text-gold mb-4">Our Services</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/services" className="hover:text-gold btn-transition">Haircuts & Styling</Link></li>
              <li><Link to="/services" className="hover:text-gold btn-transition">Hair Treatments</Link></li>
              <li><Link to="/services" className="hover:text-gold btn-transition">Facials & Skin Care</Link></li>
              <li><Link to="/nail-studio" className="hover:text-gold btn-transition">Nail Extensions</Link></li>
              <li><Link to="/services" className="hover:text-gold btn-transition">Grooming Services</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-800 text-center text-sm text-neutral-500">
          &copy; {new Date().getFullYear()} {SALON.fullName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
